<template>
  <div v-if="!['system_admin'].includes(profileObject.role)">
    <v-row class="ma-0 Language-Width">
      <v-col cols="12">
        <SelectField
          name="language"
          label="Language"
          :itemsList="languageList"
          itemText="label"
          itemValue="value"
          :isClearable="false"
          prepend-inner-icon="mdi-translate"
          v-model="newCurrentLanguage"
          @change="googleTranslateElementInit($event, true)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getCookie, setCookie, eraseCookie } from "@/utils/cookieHandlers";
import { languageList } from "@/utils/fieldConstants";
import { productFruits } from "product-fruits";

export default {
  data() {
    return {
      languageList,
      newCurrentLanguage: null,
      languagesValue: "en,ar,es,fr,de,nl",
    };
  },
  computed: {
    profileObject() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      return obj;
    },
  },
  methods: {
    googleTranslateElementInit(language = null, reload = false) {
      if (!language) {
        return;
      }

      // New selected update in local store Preferred Language
      // await this.updatePreferredLanguage(language);

      // Take English
      const previousLanguage = "en";
      // update new 'currentLanguage' Cookie
      setCookie("currentLanguage", language);

      // Remove previous 'googtrans' Cookie
      if (getCookie("googtrans")) {
        eraseCookie("googtrans");
      }
      // Update new 'googtrans' Cookie
      setCookie("googtrans", `/${previousLanguage}/${language}`);

      // And then reload page
      if (reload) {
        location.reload();
      }
    },

    loadLang() {
      // First check Cookies is available
      const checkCookies = getCookie("currentLanguage");
      const checkGoogtransCookies = getCookie("googtrans");

      // Get user preferred language from local storage
      this.newCurrentLanguage = checkCookies ? checkCookies : "en";

      if (
        !checkCookies &&
        !checkGoogtransCookies &&
        this.newCurrentLanguage != "en"
      ) {
        // If not then get Default Language from Local Storage
        // And set as currentLanguage Cookie
        setCookie("currentLanguage", this.newCurrentLanguage);

        // Previous Language default set English
        // You can set any language that doesn't matter
        const previousLanguage = "en";
        // Now set 'googtrans' Cookie
        setCookie(
          "googtrans",
          `/${previousLanguage}/${this.newCurrentLanguage}`
        );
      }

      new google.translate.TranslateElement(
        {
          pageLanguage: "en",
          layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: true,
          includedLanguages: this.languagesValue,
        },
        "app"
      );

      // Product Fruits
      if (process.env.VUE_APP_PRODUCT_FRUITS) {
        productFruits.init(process.env.VUE_APP_PRODUCT_FRUITS, "en", {
          username: this.profileObject.username,
        });
      }
    },
  },
  mounted() {
    if (!["system_admin"].includes(this.profileObject.role)) {
      const interval = setInterval(() => {
        if (
          window?.google?.translate &&
          window.google.translate.TranslateElement
        ) {
          clearInterval(interval);
          this.loadLang();
        }
      }, 500);
    }
  },
};
</script>

<style>
.Language-Width {
  width: 200px;
}
</style>